import moment from 'moment';
import i18n from 'services/i18n';
import { TREATMENT_LENGTH_MAX } from 'constants/forms';

export default values => {
  const errors = {};

  if (values.leadsPresent && !/^\+?(0|[1-9]\d*)$/.test(values.percentAtrialPacing)) {
    errors.percentAtrialPacing = i18n.t('validation:integerPositive');
  }

  if (!/^\+?(0|[1-9]\d*)$/.test(values.percentVentricularPacing)) {
    errors.percentVentricularPacing = i18n.t('validation:integerPositive');
  }
  if (!values.percentVentricularPacing) {
    errors.percentVentricularPacing = i18n.t('validation:fieldRequired');
  }

  if (values.anyVentricularArrhythmiasDetected) {
    if (
      values.anyVentricularArrhythmiasDetectedDate &&
      !moment(values.anyVentricularArrhythmiasDetectedDate, 'MM/DD/YYYY', true).isValid()
    ) {
      errors.anyVentricularArrhythmiasDetectedDate = i18n.t('validation:dateFormat');
    }
    if (!values.anyVentricularArrhythmiasDetectedDate) {
      errors.anyVentricularArrhythmiasDetectedDate = i18n.t('validation:fieldRequired');
    }

    if (!/^\+?(0|[1-9]\d*)$/.test(values.anyVentricularArrhythmiasDetectedRate)) {
      errors.anyVentricularArrhythmiasDetectedRate = i18n.t('validation:integerPositive');
    }
    if (!values.anyVentricularArrhythmiasDetectedRate) {
      errors.anyVentricularArrhythmiasDetectedRate = i18n.t('validation:fieldRequired');
    }
    if (
      values.anyVentricularArrhythmiasDetectedTreatment &&
      values.anyVentricularArrhythmiasDetectedTreatment.length > 100
    ) {
      errors.anyVentricularArrhythmiasDetectedTreatment = i18n.t('validation:maximunCharacters', {
        value: TREATMENT_LENGTH_MAX,
      });
    }
    if (!values.anyVentricularArrhythmiasDetectedTreatment) {
      errors.anyVentricularArrhythmiasDetectedTreatment = i18n.t('validation:fieldRequired');
    }
  }

  if (values.anyAtrialArrhythmiasDetected) {
    if (
      values.anyAtrialArrhythmiasDetectedDate &&
      !moment(values.anyAtrialArrhythmiasDetectedDate, 'MM/DD/YYYY', true).isValid()
    ) {
      errors.anyAtrialArrhythmiasDetectedDate = i18n.t('validation:dateFormat');
    }
    if (!values.anyAtrialArrhythmiasDetectedDate) {
      errors.anyAtrialArrhythmiasDetectedDate = i18n.t('validation:fieldRequired');
    }

    if (!/^\+?(0|[1-9]\d*)$/.test(values.anyAtrialArrhythmiasDetectedRate)) {
      errors.anyAtrialArrhythmiasDetectedRate = i18n.t('validation:integerPositive');
    }
    if (!values.anyAtrialArrhythmiasDetectedRate) {
      errors.anyAtrialArrhythmiasDetectedRate = i18n.t('validation:fieldRequired');
    }
    if (
      !/^\+?(0|[1-9]\d*) (Minutes|Hours|Days)|Continuous/.test(
        values.anyAtrialArrhythmiasDetectedTimeLength,
      )
    ) {
      errors.anyAtrialArrhythmiasDetectedTimeLength = i18n.t('validation:integerPositive');
    }
    if (!values.anyAtrialArrhythmiasDetectedTimeLength) {
      errors.anyAtrialArrhythmiasDetectedTimeLength = i18n.t('validation:fieldRequired');
    }
  }

  return errors;
};
